
// SVG Icon: minimize
export default { id: "terriajs-minimize" };
export const id = "terriajs-minimize";
export const name = "minimize";
